<template>
  <section class="section" v-if="getUserPdfs && getUserPdfs.length > 0">
    <h1 class="title">
      Continue Reading your PDFs
    </h1>
    <b-table :data="getUserPdfs" :loading="isLocalLoading">
      <template slot-scope="props">
        <b-table-column field="title" label="Title" width="280">
          {{ props.row.fileName }}
        </b-table-column>
        <b-table-column field="currentPageNum" label="Current Page" width="280">
          {{ props.row.currentPageNum }}
        </b-table-column>
        <b-table-column field="numPages" label="Number of Pages" width="280">
          {{ props.row.numPages }}
        </b-table-column>
        <b-table-column width="150">
          <button type="button" class="button is-white" @click="readPdf(props.row.id)">
            Read
          </button>
        </b-table-column>
      </template>
    </b-table>
  </section>
</template>

<script>
export default {
  name: 'userPdfsList',
  created () {
    this.$store.dispatch('getUserPdfs')
  },
  methods: {
    readPdf (id) {
      this.$router.push(`/pdf/${id}`)
    }
  },
  computed: {
    getUserPdfs () {
      return this.$store.getters.getUserPdfs
    },
    isAuthenticated () {
      return this.$store.getters.isAuthenticated
    },
    isLocalLoading () {
      const localLoading = this.$store.getters.isLocalLoading
      return localLoading.componentId === 'userPdfsList' && localLoading.active
    }
  }
}
</script>
